import React from 'react';

interface SectionBackgroundProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
  variant?: 'default' | 'dark' | 'light' | 'white' | 'cream';
}

const SectionBackground = React.forwardRef<HTMLElement, SectionBackgroundProps>(({ 
  children, 
  style = {}, 
  className,
  variant = 'default'
}, ref) => {
  const getBackgroundStyle = () => {
    switch (variant) {
      case 'white':
        return {
          background: '#FFFFFF'
        };
      case 'cream':
        return {
          background: '#F8F6F3'
        };
      case 'dark':
        return {
          background: '#F8F6F3'
        };
      case 'light':
        return {
          background: '#FFFFFF'
        };
      default:
        return {
          background: '#FFFFFF'
        };
    }
  };

  return (
    <section 
      ref={ref}
      className={className}
      style={{ 
        position: 'relative', 
        overflow: 'hidden',
        ...getBackgroundStyle(),
        ...style 
      }}
    >
      
      {children}
    </section>
  );
});

SectionBackground.displayName = 'SectionBackground';

export default SectionBackground;